/** Emails allowed to see the Jobotics “Demo live projects” entry point and /digital-twin-demo. */
const ALLOWED_DIGITAL_TWIN_DEMO_EMAILS = new Set([
  'robert.dong@jobotics.ai',
  'jake@jobotics.ai',
  'skye@jobotics.ai',
  // Username/password demo login (POST /api/auth/login) provisions the user
  // with this email by default — see DEMO_ADMIN_EMAIL in server/routes/auth.js.
  // Adding it here so anyone who signs in as admin/jobotics2025 gets the
  // same Demo section the 3 named demo accounts see.
  'admin@jobotics.ai',
]);

export function canAccessDigitalTwinDemo(email) {
  if (!email || typeof email !== 'string') return false;
  return ALLOWED_DIGITAL_TWIN_DEMO_EMAILS.has(email.trim().toLowerCase());
}
